export const PartBOMValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.selectedPart.PK_Stock_ID) {
        errors.File = 'This field is required';
    }

    return errors;
};
